import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../Icon/Icon';
import './Toast.scss';

export type ToastType = 'success' | 'error' | 'info' | 'warning';
export type ToastVariant = 'system' | 'notification';

interface ToastProps {
  id: string;
  type: ToastType;
  message: string;
  title?: string;
  duration?: number;
  href?: string;
  variant?: ToastVariant;
  onClose: (id: string) => void;
}

const Toast: React.FC<ToastProps> = ({
  id,
  type,
  message,
  title,
  duration = 5000,
  href,
  variant = 'system',
  onClose
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => onClose(id), duration);
    return () => clearTimeout(timer);
  }, [id, duration, onClose]);

  const icon =
    type === 'success'
      ? 'check-circle'
      : type === 'error'
        ? 'x-circle'
        : type === 'warning'
          ? 'alert-triangle'
          : 'bell';

  const open = () => {
    if (!href) return;
    onClose(id);
    navigate(href);
  };

  return (
    <div
      className={`toast toast--${type}${variant === 'notification' ? ' toast--notif' : ''}${
        href ? ' is-link' : ''
      }`}
      style={{ ['--toast-duration' as string]: `${duration}ms` }}
      role={href ? 'link' : 'status'}
      onClick={href ? open : undefined}
    >
      <div className="toast__icon">
        <Icon name={icon} size={16} />
      </div>
      <div className="toast__content">
        {title ? <div className="toast__title">{title}</div> : null}
        <div className="toast__message">{message}</div>
      </div>
      {href ? <Icon name="chevron-right" size={12} className="toast__go" /> : null}
      <button
        type="button"
        className="toast__close"
        onClick={e => {
          e.stopPropagation();
          onClose(id);
        }}
        aria-label="Fermer"
      >
        <Icon name="x" size={12} />
      </button>
    </div>
  );
};

export default Toast;
